import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import {
  CreateAddressButtonContainer,
  addAddressButtonOverrides,
} from '@/containers/SubscriptionFormPageNew/Components/Address/styled-components'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'

const AddAddressButton = () => {
  const { t, addressesList, updateActiveAddressHandler } = useAddress()

  if (!addressesList.length) {
    return null
  }

  return (
    <CreateAddressButtonContainer>
      <SDButton onClick={() => updateActiveAddressHandler('new')} overrides={addAddressButtonOverrides}>
        {t('subscriptionForm:address_v2.new_address_title')}
      </SDButton>
    </CreateAddressButtonContainer>
  )
}

export default AddAddressButton
